__turbopack_context__.v({
  "focus": "styles-module-scss-module__FoZYiq__focus",
  "focus__text": "styles-module-scss-module__FoZYiq__focus__text",
  "focus__text_wrapper": "styles-module-scss-module__FoZYiq__focus__text_wrapper",
});
